import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=d472e20e&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=d472e20e&scoped=true&lang=css&"
import style1 from "./Aside.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d472e20e",
  null
  
)

export default component.exports